import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const updateCampaignSegments = async (domain: string, campaignId: number, segmentIds: number[], consentRule: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/segments`,
        method: 'POST',
        params: {
            segmentIds: segmentIds,
            consentRule,
        },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}